import { Grid, Skeleton, Box } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { ProcessStep } from '../../common/enums/enums';
import SectionTitle from '../SectionTitle';
import Timer from '../Timer';
import WorkOrderStepperV2 from '../WorkOrderStepperV2';

const WOrderStepper = ({
  isVendor,
  isManager,
  data,
  onStatusChange = null,
  statusCancel = null,
  isLoading,
  isApiLoading,
  showDetail = true,
  isTechnicianAssigned = false,
}) => {
  const { t } = useTranslation('workOrdersTable');

  return !isLoading ? (
    <Box
      sx={{
        bgcolor:
          data.step !== ProcessStep.PAUSED
            ? 'background.paper'
            : theme => theme.palette.grey[100],
        p: { xs: 2, lg: 4 },
        borderTop: '1px solid',
        borderColor: theme => theme.palette.divider,
      }}
    >
      <Grid container flexDirection="column">
        <Grid item>
          <Grid container flexDirection="row" justifyContent="space-between">
            <Grid item>
              <SectionTitle
                title={t('card.hiddenContent.processStepstitle')}
                subsection={true}
              />
            </Grid>
            <Grid item>
              <Timer currentStep={data?.step} steps={data?.workFlowHistory} />
            </Grid>
          </Grid>
        </Grid>
        <Grid item>
          <WorkOrderStepperV2
            isVendor={isVendor}
            isManager={isManager}
            isBilled={data?.isBilled}
            hasQualitySurvey={data?.woQualitySurveyId}
            vendorOrderId={data?.vendorOrderId}
            steps={data?.workFlowHistory}
            isApiLoading={isApiLoading}
            onStatusChange={onStatusChange}
            statusCancel={statusCancel}
            detail={showDetail}
            woNumber={data?.woNumber}
            isTechnicianAssigned={isTechnicianAssigned}
          />
        </Grid>
      </Grid>
    </Box>
  ) : (
    <Box
      data-testid="skeleton"
      sx={{
        bgcolor: 'background.paper',
        p: { xs: 2, lg: 4 },
        borderTop: '1px solid',
        borderColor: theme => theme.palette.divider,
      }}
    >
      <Grid container flexDirection="column">
        <Grid item xs={12}>
          <Grid container flexDirection="row" justifyContent="space-between">
            <Grid item>
              <Skeleton variant="text" width={120} />
            </Grid>
            <Grid item>
              <Skeleton variant="rounded" width={180} height={40} />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <Grid container flexDirection="row" spacing={{ xs: 0, md: 2 }}>
            {[...Array(6)].map((_, j) => (
              <Grid key={j} item xs={12} md={2}>
                <Skeleton
                  height={80}
                  sx={{ width: { xs: '60%', sm: '40%', md: '100%' } }}
                />
              </Grid>
            ))}
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <Grid container justifyContent="flex-end">
            <Grid item>
              <Skeleton variant="rounded" width={180} height={40} />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
};

export default WOrderStepper;
